
            const data = {"name":"icon-arrow-wide-down","data":{"width":"32","height":"32","viewBox":"0 0 32 32","data":"<path pid=\"0\" _fill=\"currentColor\" d=\"M.457 12.641a.37.37 0 01.316-.668l15.385 7.28a.37.37 0 01-.316.668L.457 12.641z\"/><path pid=\"1\" _fill=\"currentColor\" d=\"M16.156 19.922a.37.37 0 01-.312-.67l15.618-7.28a.37.37 0 01.312.67l-15.618 7.28z\"/>"}}
        
                module.exports = data
                